export const HARDCODED_EXAMPLES = [
  // Mobile Applications
  {
    id: 1,
    title: "Sync My Meet",
    technologies: "Expo + React, Mapbox, Firebase",
    description: "Built a group navigation and event organization cross-platform application. Features include crew navigation, friends, event organization, user registration, etc.",
    tags: "Expo, React, Mapbox, Firebase, mobile, navigation, events",
    category: "Mobile Applications",
    link: "http://syncmyrideapp.com",
    caseStudy: "https://www.upwork.com/fl/trevorhawkins?p=1855444045072556032"
  },
  {
    id: 2,
    title: "Rate the Refs",
    technologies: "React Native, Heroku, Firebase",
    description: "Sports application where fans can sign up, connect with friends and other members, chat about games, check scores and news, etc.",
    tags: "React Native, Heroku, Firebase, mobile, sports, social",
    category: "Mobile Applications",
    link: "https://apps.apple.com/us/app/rate-the-refs/id1498988232",
    caseStudy: "https://www.upwork.com/fl/trevorhawkins?p=1854605152687943680"
  },
  {
    id: 3,
    title: "SpendHer",
    technologies: "Expo + React, Firebase, Stripe",
    description: "Built a mobile application where creators and customers can connect via voice, video, and message chats. Integrated a dual purpose payment system with Stripe, connected payout accounts, and a host of features like screenshot protection, realtime notifications, subscriptions, payout systems, etc.",
    tags: "Expo, React, Firebase, Stripe, mobile, payments, video chat, subscriptions",
    category: "Mobile Applications",
    link: "http://spendherapp.com",
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1953590695837392896"
  },
  
  // Education
  {
    id: 4,
    title: "MyTassel",
    technologies: "Expo + React, AWS, Stripe",
    description: "A website and web app where graduates and their friends and family can connect, schedule and share event details, create registries, sign yearbooks, and much more.",
    tags: "Expo, React, AWS, Stripe, web, education, events",
    category: "Education",
    link: "http://mytassel.com/",
    caseStudy: "https://www.upwork.com/fl/~0163dfe024936983dd?p=1855137945228447744"
  },
  {
    id: 5,
    title: "UNC Chapel Hill's TEAAS",
    technologies: "Expo + React, Firebase",
    description: "Assisted in the design and development of key sections of UNC Chapel Hill's engineering field testing web exams, systems, and field equipment.",
    tags: "Expo, React, Firebase, education, testing, university",
    category: "Education",
    link: "http://roadsafetyacademy.org/",
    caseStudy: "https://www.upwork.com/fl/~0163dfe024936983dd?p=1863093599942287360"
  },
  
  // Sports & Service
  {
    id: 6,
    title: "Somerset Country Club",
    technologies: "Expo + React, Firebase",
    description: "Redesigned a country club website, which included adding an interactive map feature where visitors and club members could map out routes to the club, get traffic data, and plan future trips.",
    tags: "Expo, React, Firebase, website, maps, hospitality",
    category: "Sports & Service",
    link: null,
    caseStudy: "https://www.upwork.com/fl/trevorhawkins?p=1855133927284293632"
  },
  {
    id: 7,
    title: "Lids: They Gave Us Game",
    technologies: "WordPress, WooCommerce, Figma",
    description: "Designed and developed the They Gave Us Game campaign for Lids during Black History Month. This campaign highlighted the founders and legends of the past 60+ years across the MLB, NBA, and other leagues. Created the UX/UI design for the project and the customer user journey and sales funnels.",
    tags: "WordPress, WooCommerce, Figma, ecommerce, sports, campaign",
    category: "Sports & Service",
    link: null,
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1863484251362336768"
  },
  {
    id: 8,
    title: "Sports Illustrated Clubhouse",
    technologies: "WordPress",
    description: "A complete restaurant website redesign for The Sports Illustrated Clubhouse restaurants.",
    tags: "WordPress, website, restaurant, sports, hospitality",
    category: "Sports & Service",
    link: "https://sportsillustratedeats.com/",
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1939198606655168512"
  },
  
  // eCommerce & Services
  {
    id: 9,
    title: "Thrdd",
    technologies: "Shopify",
    description: "A direct-to-consumer e-commerce platform specializing in premium apparel with a focus on empowering women's basketball culture. Within three months of launch, achieved over $15,000 in revenue, 4500+ monthly visitors, and built a strong, engaged customer base.",
    tags: "Shopify, ecommerce, apparel, sports, marketing",
    category: "eCommerce & Services",
    link: "http://thrdd.com",
    caseStudy: "https://contra.com/p/mg7XXvoq-thrdd-e-commerce-website-design-development-and-marketing"
  },
  {
    id: 10,
    title: "Nano Genesis Labs",
    technologies: "Shopify",
    description: "A brain boosting supplement lab and storefront aimed at providing cutting edge solutions toward extending life spans and improving livelihood for all. Helped redesign their website and provide key insights and assets for the marketing materials.",
    tags: "Shopify, ecommerce, health, supplements, marketing",
    category: "eCommerce & Services",
    link: "http://nanogenesislabs.com/",
    caseStudy: null
  },
  {
    id: 11,
    title: "Security Central Protection",
    technologies: "Figma, Twilio, Expo + React, Firebase, Stripe",
    description: "A complete website overhaul meant to enhance user experience, integrate seamless payment solutions, and develop a customizable step-wise service package builder.",
    tags: "Figma, Twilio, Expo, React, Firebase, Stripe, website, security, payments",
    category: "eCommerce & Services",
    link: "http://scp911.com",
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1891663952428875776"
  },
  {
    id: 12,
    title: "Dsignable",
    technologies: "Webflow, Make",
    description: "Our company website built with Webflow. Integrates custom CMS, APIs, and automations from custom-made and third party softwares. Features smooth scrolling, dynamic content, and clean UX/UI design.",
    tags: "Webflow, Make, CMS, automation, website, agency",
    category: "eCommerce & Services",
    link: "http://dsignable.com",
    caseStudy: null
  },
  
  // Construction
  {
    id: 13,
    title: "Allied Outdoor Solutions",
    technologies: "WordPress",
    description: "Assisted in the design and development of key sections of this architectural consulting website.",
    tags: "WordPress, website, construction, architecture, consulting",
    category: "Construction",
    link: "http://alliedoutdoorsolutions.com/",
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1887345349982801920"
  },
  
  // Productivity
  {
    id: 14,
    title: "Flomodo",
    technologies: "Expo + React, Firebase",
    description: "An AI-based Pomodoro style mobile, web, and wearable app that tracks users' workflows and helps them get to their flow state more efficiently. Set to launch November 2025.",
    tags: "Expo, React, Firebase, AI, productivity, mobile, web, wearable",
    category: "Productivity",
    link: null,
    caseStudy: null
  },
  {
    id: 15,
    title: "Venue Report Card",
    technologies: "Expo + React, Firebase, Stripe",
    description: "An AI-based music tour mapping and venue grading/reporting web and mobile app that allows artists, attendees, tour managers, employees, and venue owners to chat about their favorite venues, map routes, and leave reviews.",
    tags: "Expo, React, Firebase, Stripe, AI, music, maps, reviews",
    category: "Productivity",
    link: "http://venuereportcard.com/",
    caseStudy: "https://www.upwork.com/freelancers/trevorhawkins?p=1891677514773774336"
  },
  
  // AI & ML
  {
    id: 16,
    title: "NextPlay",
    technologies: "Figma, Python, React, SQL, ML, AI, GCP, Supabase, Firebase, Stripe",
    description: "Built a Machine learning based platform to identify and track player movement, ball position, and play type to help give coaches realtime insights and analytics about their game film.",
    tags: "Figma, Python, React, SQL, ML, AI, GCP, Supabase, Firebase, Stripe, sports, analytics",
    category: "AI & ML",
    link: "https://gridiron-analytics-engine.vercel.app/",
    caseStudy: null
  },
  
  // Software & Extensions
  {
    id: 17,
    title: "ESAX",
    technologies: "Unity, XCode",
    description: "Built an AR/VR experience for visually impaired users on Unity and iOS with XCode. Mapped AR world-space to real world locations for museum presentations. Simulated real world environments to convey the experience of visual impairments while navigating everyday real-world situations, like crossing streets, interacting with other users across the country, etc.",
    tags: "Unity, XCode, AR, VR, iOS, accessibility, museum",
    category: "Software & Extensions",
    link: null,
    caseStudy: null
  },
  {
    id: 18,
    title: "Lua Chrome Extension and Application",
    technologies: "Expo + React, Firebase, Stripe",
    description: "Chrome extension and application for language learning and productivity.",
    tags: "Expo, React, Firebase, Stripe, Chrome Extension, education",
    category: "Software & Extensions",
    link: "http://learnwithlua.com",
    caseStudy: null
  }
];
